"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadKeycloakFromServer = void 0;
function loadKeycloakFromServer(keycloakUrl) {
    return new Promise(function (resolve, reject) {
        console.debug("Loading keycloak-js from the keycloak server");
        var scriptTag = document.createElement('script');
        scriptTag.src = keycloakUrl + "/js/keycloak.js";
        scriptTag.onerror = function (_) {
            reject(new Error("keycloak-js could not be loaded from " + scriptTag.src));
        };
        scriptTag.onload = function () {
            console.debug("Finished loading keycloak-js");
            if (!window.Keycloak)
                reject(new Error("The source loaded from " + scriptTag.src + " did not correctly initialize keycloak-js"));
            var KC = window.Keycloak;
            delete window.Keycloak;
            document.head.removeChild(scriptTag);
            resolve(KC);
        };
        document.head.appendChild(scriptTag);
    });
}
exports.loadKeycloakFromServer = loadKeycloakFromServer;
